var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732739112305,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 16308,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M806.88 1002H202.2C90.74 1002 0.07 911.33 0.07 799.85V242.26c0-111.48 90.67-202.15 202.12-202.15h604.69c111.48 0 202.15 90.67 202.15 202.15v557.59c0 111.48-90.67 202.15-202.15 202.15zM202.2 120.61c-67.06 0-121.62 54.56-121.62 121.64v557.59c0 67.09 54.56 121.64 121.62 121.64h604.69c67.09 0 121.64-54.56 121.64-121.64V242.26c0-67.09-54.56-121.64-121.64-121.64l-604.69-0.01z",
    fill: "#333333",
    "p-id": 16309
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.31 395.56h522.48v80.5H243.31zM243.31 608.82h292.74v80.5H243.31z",
    fill: "#333333",
    "p-id": 16310
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.a3cd6d308a8933f0a1e79203e29ded98.svg";
export { ForwardRef as ReactComponent };